/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import { Order } from '../../../../core/channel/v1/channel'
import {
  InterchainAccountPacketData,
  InterchainAccountPacketDataAmino,
  InterchainAccountPacketDataSDKType
} from '../../v1/packet'
import { Params, ParamsAmino, ParamsSDKType } from './controller'
import { isSet } from '../../../../../../helpers'
import { BinaryReader, BinaryWriter } from '../../../../../../binary'
import { GlobalDecoderRegistry } from '../../../../../registry'
/** MsgRegisterInterchainAccount defines the payload for Msg/RegisterAccount */
export interface MsgRegisterInterchainAccount {
  owner: string
  connectionId: string
  version: string
  ordering: Order
}
export interface MsgRegisterInterchainAccountProtoMsg {
  typeUrl: '/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount'
  value: Uint8Array
}
/** MsgRegisterInterchainAccount defines the payload for Msg/RegisterAccount */
export interface MsgRegisterInterchainAccountAmino {
  owner?: string
  connection_id?: string
  version?: string
  ordering?: Order
}
export interface MsgRegisterInterchainAccountAminoMsg {
  type: 'cosmos-sdk/MsgRegisterInterchainAccount'
  value: MsgRegisterInterchainAccountAmino
}
/** MsgRegisterInterchainAccount defines the payload for Msg/RegisterAccount */
export interface MsgRegisterInterchainAccountSDKType {
  owner: string
  connection_id: string
  version: string
  ordering: Order
}
/** MsgRegisterInterchainAccountResponse defines the response for Msg/RegisterAccount */
export interface MsgRegisterInterchainAccountResponse {
  channelId: string
  portId: string
}
export interface MsgRegisterInterchainAccountResponseProtoMsg {
  typeUrl: '/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccountResponse'
  value: Uint8Array
}
/** MsgRegisterInterchainAccountResponse defines the response for Msg/RegisterAccount */
export interface MsgRegisterInterchainAccountResponseAmino {
  channel_id?: string
  port_id?: string
}
export interface MsgRegisterInterchainAccountResponseAminoMsg {
  type: 'cosmos-sdk/MsgRegisterInterchainAccountResponse'
  value: MsgRegisterInterchainAccountResponseAmino
}
/** MsgRegisterInterchainAccountResponse defines the response for Msg/RegisterAccount */
export interface MsgRegisterInterchainAccountResponseSDKType {
  channel_id: string
  port_id: string
}
/** MsgSendTx defines the payload for Msg/SendTx */
export interface MsgSendTx {
  owner: string
  connectionId: string
  packetData: InterchainAccountPacketData
  /**
   * Relative timeout timestamp provided will be added to the current block time during transaction execution.
   * The timeout timestamp must be non-zero.
   */
  relativeTimeout: bigint
}
export interface MsgSendTxProtoMsg {
  typeUrl: '/ibc.applications.interchain_accounts.controller.v1.MsgSendTx'
  value: Uint8Array
}
/** MsgSendTx defines the payload for Msg/SendTx */
export interface MsgSendTxAmino {
  owner?: string
  connection_id?: string
  packet_data?: InterchainAccountPacketDataAmino
  /**
   * Relative timeout timestamp provided will be added to the current block time during transaction execution.
   * The timeout timestamp must be non-zero.
   */
  relative_timeout?: string
}
export interface MsgSendTxAminoMsg {
  type: 'cosmos-sdk/MsgSendTx'
  value: MsgSendTxAmino
}
/** MsgSendTx defines the payload for Msg/SendTx */
export interface MsgSendTxSDKType {
  owner: string
  connection_id: string
  packet_data: InterchainAccountPacketDataSDKType
  relative_timeout: bigint
}
/** MsgSendTxResponse defines the response for MsgSendTx */
export interface MsgSendTxResponse {
  sequence: bigint
}
export interface MsgSendTxResponseProtoMsg {
  typeUrl: '/ibc.applications.interchain_accounts.controller.v1.MsgSendTxResponse'
  value: Uint8Array
}
/** MsgSendTxResponse defines the response for MsgSendTx */
export interface MsgSendTxResponseAmino {
  sequence?: string
}
export interface MsgSendTxResponseAminoMsg {
  type: 'cosmos-sdk/MsgSendTxResponse'
  value: MsgSendTxResponseAmino
}
/** MsgSendTxResponse defines the response for MsgSendTx */
export interface MsgSendTxResponseSDKType {
  sequence: bigint
}
/** MsgUpdateParams defines the payload for Msg/UpdateParams */
export interface MsgUpdateParams {
  /** signer address */
  signer: string
  /**
   * params defines the 27-interchain-accounts/controller parameters to update.
   *
   * NOTE: All parameters must be supplied.
   */
  params: Params
}
export interface MsgUpdateParamsProtoMsg {
  typeUrl: '/ibc.applications.interchain_accounts.controller.v1.MsgUpdateParams'
  value: Uint8Array
}
/** MsgUpdateParams defines the payload for Msg/UpdateParams */
export interface MsgUpdateParamsAmino {
  /** signer address */
  signer?: string
  /**
   * params defines the 27-interchain-accounts/controller parameters to update.
   *
   * NOTE: All parameters must be supplied.
   */
  params?: ParamsAmino
}
export interface MsgUpdateParamsAminoMsg {
  type: 'cosmos-sdk/MsgUpdateParams'
  value: MsgUpdateParamsAmino
}
/** MsgUpdateParams defines the payload for Msg/UpdateParams */
export interface MsgUpdateParamsSDKType {
  signer: string
  params: ParamsSDKType
}
/** MsgUpdateParamsResponse defines the response for Msg/UpdateParams */
export interface MsgUpdateParamsResponse {}
export interface MsgUpdateParamsResponseProtoMsg {
  typeUrl: '/ibc.applications.interchain_accounts.controller.v1.MsgUpdateParamsResponse'
  value: Uint8Array
}
/** MsgUpdateParamsResponse defines the response for Msg/UpdateParams */
export interface MsgUpdateParamsResponseAmino {}
export interface MsgUpdateParamsResponseAminoMsg {
  type: 'cosmos-sdk/MsgUpdateParamsResponse'
  value: MsgUpdateParamsResponseAmino
}
/** MsgUpdateParamsResponse defines the response for Msg/UpdateParams */
export interface MsgUpdateParamsResponseSDKType {}
function createBaseMsgRegisterInterchainAccount(): MsgRegisterInterchainAccount {
  return {
    owner: '',
    connectionId: '',
    version: '',
    ordering: 0
  }
}
export const MsgRegisterInterchainAccount = {
  typeUrl:
    '/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount',
  aminoType: 'cosmos-sdk/MsgRegisterInterchainAccount',
  is(o: any): o is MsgRegisterInterchainAccount {
    return (
      o &&
      (o.$typeUrl === MsgRegisterInterchainAccount.typeUrl ||
        (typeof o.owner === 'string' &&
          typeof o.connectionId === 'string' &&
          typeof o.version === 'string' &&
          isSet(o.ordering)))
    )
  },
  isSDK(o: any): o is MsgRegisterInterchainAccountSDKType {
    return (
      o &&
      (o.$typeUrl === MsgRegisterInterchainAccount.typeUrl ||
        (typeof o.owner === 'string' &&
          typeof o.connection_id === 'string' &&
          typeof o.version === 'string' &&
          isSet(o.ordering)))
    )
  },
  isAmino(o: any): o is MsgRegisterInterchainAccountAmino {
    return (
      o &&
      (o.$typeUrl === MsgRegisterInterchainAccount.typeUrl ||
        (typeof o.owner === 'string' &&
          typeof o.connection_id === 'string' &&
          typeof o.version === 'string' &&
          isSet(o.ordering)))
    )
  },
  encode(
    message: MsgRegisterInterchainAccount,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.owner !== '') {
      writer.uint32(10).string(message.owner)
    }
    if (message.connectionId !== '') {
      writer.uint32(18).string(message.connectionId)
    }
    if (message.version !== '') {
      writer.uint32(26).string(message.version)
    }
    if (message.ordering !== 0) {
      writer.uint32(32).int32(message.ordering)
    }
    return writer
  },
  decode(
    input: BinaryReader | Uint8Array,
    length?: number
  ): MsgRegisterInterchainAccount {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMsgRegisterInterchainAccount()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string()
          break
        case 2:
          message.connectionId = reader.string()
          break
        case 3:
          message.version = reader.string()
          break
        case 4:
          message.ordering = reader.int32() as any
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },
  fromPartial(
    object: Partial<MsgRegisterInterchainAccount>
  ): MsgRegisterInterchainAccount {
    const message = createBaseMsgRegisterInterchainAccount()
    message.owner = object.owner ?? ''
    message.connectionId = object.connectionId ?? ''
    message.version = object.version ?? ''
    message.ordering = object.ordering ?? 0
    return message
  },
  fromAmino(
    object: MsgRegisterInterchainAccountAmino
  ): MsgRegisterInterchainAccount {
    const message = createBaseMsgRegisterInterchainAccount()
    if (object.owner !== undefined && object.owner !== null) {
      message.owner = object.owner
    }
    if (object.connection_id !== undefined && object.connection_id !== null) {
      message.connectionId = object.connection_id
    }
    if (object.version !== undefined && object.version !== null) {
      message.version = object.version
    }
    if (object.ordering !== undefined && object.ordering !== null) {
      message.ordering = object.ordering
    }
    return message
  },
  toAmino(
    message: MsgRegisterInterchainAccount
  ): MsgRegisterInterchainAccountAmino {
    const obj: any = {}
    obj.owner = message.owner === '' ? undefined : message.owner
    obj.connection_id =
      message.connectionId === '' ? undefined : message.connectionId
    obj.version = message.version === '' ? undefined : message.version
    obj.ordering = message.ordering === 0 ? undefined : message.ordering
    return obj
  },
  fromAminoMsg(
    object: MsgRegisterInterchainAccountAminoMsg
  ): MsgRegisterInterchainAccount {
    return MsgRegisterInterchainAccount.fromAmino(object.value)
  },
  toAminoMsg(
    message: MsgRegisterInterchainAccount
  ): MsgRegisterInterchainAccountAminoMsg {
    return {
      type: 'cosmos-sdk/MsgRegisterInterchainAccount',
      value: MsgRegisterInterchainAccount.toAmino(message)
    }
  },
  fromProtoMsg(
    message: MsgRegisterInterchainAccountProtoMsg
  ): MsgRegisterInterchainAccount {
    return MsgRegisterInterchainAccount.decode(message.value)
  },
  toProto(message: MsgRegisterInterchainAccount): Uint8Array {
    return MsgRegisterInterchainAccount.encode(message).finish()
  },
  toProtoMsg(
    message: MsgRegisterInterchainAccount
  ): MsgRegisterInterchainAccountProtoMsg {
    return {
      typeUrl:
        '/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccount',
      value: MsgRegisterInterchainAccount.encode(message).finish()
    }
  }
}
GlobalDecoderRegistry.register(
  MsgRegisterInterchainAccount.typeUrl,
  MsgRegisterInterchainAccount
)
GlobalDecoderRegistry.registerAminoProtoMapping(
  MsgRegisterInterchainAccount.aminoType,
  MsgRegisterInterchainAccount.typeUrl
)
function createBaseMsgRegisterInterchainAccountResponse(): MsgRegisterInterchainAccountResponse {
  return {
    channelId: '',
    portId: ''
  }
}
export const MsgRegisterInterchainAccountResponse = {
  typeUrl:
    '/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccountResponse',
  aminoType: 'cosmos-sdk/MsgRegisterInterchainAccountResponse',
  is(o: any): o is MsgRegisterInterchainAccountResponse {
    return (
      o &&
      (o.$typeUrl === MsgRegisterInterchainAccountResponse.typeUrl ||
        (typeof o.channelId === 'string' && typeof o.portId === 'string'))
    )
  },
  isSDK(o: any): o is MsgRegisterInterchainAccountResponseSDKType {
    return (
      o &&
      (o.$typeUrl === MsgRegisterInterchainAccountResponse.typeUrl ||
        (typeof o.channel_id === 'string' && typeof o.port_id === 'string'))
    )
  },
  isAmino(o: any): o is MsgRegisterInterchainAccountResponseAmino {
    return (
      o &&
      (o.$typeUrl === MsgRegisterInterchainAccountResponse.typeUrl ||
        (typeof o.channel_id === 'string' && typeof o.port_id === 'string'))
    )
  },
  encode(
    message: MsgRegisterInterchainAccountResponse,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.channelId !== '') {
      writer.uint32(10).string(message.channelId)
    }
    if (message.portId !== '') {
      writer.uint32(18).string(message.portId)
    }
    return writer
  },
  decode(
    input: BinaryReader | Uint8Array,
    length?: number
  ): MsgRegisterInterchainAccountResponse {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMsgRegisterInterchainAccountResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.channelId = reader.string()
          break
        case 2:
          message.portId = reader.string()
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },
  fromPartial(
    object: Partial<MsgRegisterInterchainAccountResponse>
  ): MsgRegisterInterchainAccountResponse {
    const message = createBaseMsgRegisterInterchainAccountResponse()
    message.channelId = object.channelId ?? ''
    message.portId = object.portId ?? ''
    return message
  },
  fromAmino(
    object: MsgRegisterInterchainAccountResponseAmino
  ): MsgRegisterInterchainAccountResponse {
    const message = createBaseMsgRegisterInterchainAccountResponse()
    if (object.channel_id !== undefined && object.channel_id !== null) {
      message.channelId = object.channel_id
    }
    if (object.port_id !== undefined && object.port_id !== null) {
      message.portId = object.port_id
    }
    return message
  },
  toAmino(
    message: MsgRegisterInterchainAccountResponse
  ): MsgRegisterInterchainAccountResponseAmino {
    const obj: any = {}
    obj.channel_id = message.channelId === '' ? undefined : message.channelId
    obj.port_id = message.portId === '' ? undefined : message.portId
    return obj
  },
  fromAminoMsg(
    object: MsgRegisterInterchainAccountResponseAminoMsg
  ): MsgRegisterInterchainAccountResponse {
    return MsgRegisterInterchainAccountResponse.fromAmino(object.value)
  },
  toAminoMsg(
    message: MsgRegisterInterchainAccountResponse
  ): MsgRegisterInterchainAccountResponseAminoMsg {
    return {
      type: 'cosmos-sdk/MsgRegisterInterchainAccountResponse',
      value: MsgRegisterInterchainAccountResponse.toAmino(message)
    }
  },
  fromProtoMsg(
    message: MsgRegisterInterchainAccountResponseProtoMsg
  ): MsgRegisterInterchainAccountResponse {
    return MsgRegisterInterchainAccountResponse.decode(message.value)
  },
  toProto(message: MsgRegisterInterchainAccountResponse): Uint8Array {
    return MsgRegisterInterchainAccountResponse.encode(message).finish()
  },
  toProtoMsg(
    message: MsgRegisterInterchainAccountResponse
  ): MsgRegisterInterchainAccountResponseProtoMsg {
    return {
      typeUrl:
        '/ibc.applications.interchain_accounts.controller.v1.MsgRegisterInterchainAccountResponse',
      value: MsgRegisterInterchainAccountResponse.encode(message).finish()
    }
  }
}
GlobalDecoderRegistry.register(
  MsgRegisterInterchainAccountResponse.typeUrl,
  MsgRegisterInterchainAccountResponse
)
GlobalDecoderRegistry.registerAminoProtoMapping(
  MsgRegisterInterchainAccountResponse.aminoType,
  MsgRegisterInterchainAccountResponse.typeUrl
)
function createBaseMsgSendTx(): MsgSendTx {
  return {
    owner: '',
    connectionId: '',
    packetData: InterchainAccountPacketData.fromPartial({}),
    relativeTimeout: BigInt(0)
  }
}
export const MsgSendTx = {
  typeUrl: '/ibc.applications.interchain_accounts.controller.v1.MsgSendTx',
  aminoType: 'cosmos-sdk/MsgSendTx',
  is(o: any): o is MsgSendTx {
    return (
      o &&
      (o.$typeUrl === MsgSendTx.typeUrl ||
        (typeof o.owner === 'string' &&
          typeof o.connectionId === 'string' &&
          InterchainAccountPacketData.is(o.packetData) &&
          typeof o.relativeTimeout === 'bigint'))
    )
  },
  isSDK(o: any): o is MsgSendTxSDKType {
    return (
      o &&
      (o.$typeUrl === MsgSendTx.typeUrl ||
        (typeof o.owner === 'string' &&
          typeof o.connection_id === 'string' &&
          InterchainAccountPacketData.isSDK(o.packet_data) &&
          typeof o.relative_timeout === 'bigint'))
    )
  },
  isAmino(o: any): o is MsgSendTxAmino {
    return (
      o &&
      (o.$typeUrl === MsgSendTx.typeUrl ||
        (typeof o.owner === 'string' &&
          typeof o.connection_id === 'string' &&
          InterchainAccountPacketData.isAmino(o.packet_data) &&
          typeof o.relative_timeout === 'bigint'))
    )
  },
  encode(
    message: MsgSendTx,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.owner !== '') {
      writer.uint32(10).string(message.owner)
    }
    if (message.connectionId !== '') {
      writer.uint32(18).string(message.connectionId)
    }
    if (message.packetData !== undefined) {
      InterchainAccountPacketData.encode(
        message.packetData,
        writer.uint32(26).fork()
      ).ldelim()
    }
    if (message.relativeTimeout !== BigInt(0)) {
      writer.uint32(32).uint64(message.relativeTimeout)
    }
    return writer
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgSendTx {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMsgSendTx()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.owner = reader.string()
          break
        case 2:
          message.connectionId = reader.string()
          break
        case 3:
          message.packetData = InterchainAccountPacketData.decode(
            reader,
            reader.uint32()
          )
          break
        case 4:
          message.relativeTimeout = reader.uint64()
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },
  fromPartial(object: Partial<MsgSendTx>): MsgSendTx {
    const message = createBaseMsgSendTx()
    message.owner = object.owner ?? ''
    message.connectionId = object.connectionId ?? ''
    message.packetData =
      object.packetData !== undefined && object.packetData !== null
        ? InterchainAccountPacketData.fromPartial(object.packetData)
        : undefined
    message.relativeTimeout =
      object.relativeTimeout !== undefined && object.relativeTimeout !== null
        ? BigInt(object.relativeTimeout.toString())
        : BigInt(0)
    return message
  },
  fromAmino(object: MsgSendTxAmino): MsgSendTx {
    const message = createBaseMsgSendTx()
    if (object.owner !== undefined && object.owner !== null) {
      message.owner = object.owner
    }
    if (object.connection_id !== undefined && object.connection_id !== null) {
      message.connectionId = object.connection_id
    }
    if (object.packet_data !== undefined && object.packet_data !== null) {
      message.packetData = InterchainAccountPacketData.fromAmino(
        object.packet_data
      )
    }
    if (
      object.relative_timeout !== undefined &&
      object.relative_timeout !== null
    ) {
      message.relativeTimeout = BigInt(object.relative_timeout)
    }
    return message
  },
  toAmino(message: MsgSendTx): MsgSendTxAmino {
    const obj: any = {}
    obj.owner = message.owner === '' ? undefined : message.owner
    obj.connection_id =
      message.connectionId === '' ? undefined : message.connectionId
    obj.packet_data = message.packetData
      ? InterchainAccountPacketData.toAmino(message.packetData)
      : undefined
    obj.relative_timeout =
      message.relativeTimeout !== BigInt(0)
        ? message.relativeTimeout.toString()
        : undefined
    return obj
  },
  fromAminoMsg(object: MsgSendTxAminoMsg): MsgSendTx {
    return MsgSendTx.fromAmino(object.value)
  },
  toAminoMsg(message: MsgSendTx): MsgSendTxAminoMsg {
    return {
      type: 'cosmos-sdk/MsgSendTx',
      value: MsgSendTx.toAmino(message)
    }
  },
  fromProtoMsg(message: MsgSendTxProtoMsg): MsgSendTx {
    return MsgSendTx.decode(message.value)
  },
  toProto(message: MsgSendTx): Uint8Array {
    return MsgSendTx.encode(message).finish()
  },
  toProtoMsg(message: MsgSendTx): MsgSendTxProtoMsg {
    return {
      typeUrl: '/ibc.applications.interchain_accounts.controller.v1.MsgSendTx',
      value: MsgSendTx.encode(message).finish()
    }
  }
}
GlobalDecoderRegistry.register(MsgSendTx.typeUrl, MsgSendTx)
GlobalDecoderRegistry.registerAminoProtoMapping(
  MsgSendTx.aminoType,
  MsgSendTx.typeUrl
)
function createBaseMsgSendTxResponse(): MsgSendTxResponse {
  return {
    sequence: BigInt(0)
  }
}
export const MsgSendTxResponse = {
  typeUrl:
    '/ibc.applications.interchain_accounts.controller.v1.MsgSendTxResponse',
  aminoType: 'cosmos-sdk/MsgSendTxResponse',
  is(o: any): o is MsgSendTxResponse {
    return (
      o &&
      (o.$typeUrl === MsgSendTxResponse.typeUrl ||
        typeof o.sequence === 'bigint')
    )
  },
  isSDK(o: any): o is MsgSendTxResponseSDKType {
    return (
      o &&
      (o.$typeUrl === MsgSendTxResponse.typeUrl ||
        typeof o.sequence === 'bigint')
    )
  },
  isAmino(o: any): o is MsgSendTxResponseAmino {
    return (
      o &&
      (o.$typeUrl === MsgSendTxResponse.typeUrl ||
        typeof o.sequence === 'bigint')
    )
  },
  encode(
    message: MsgSendTxResponse,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.sequence !== BigInt(0)) {
      writer.uint32(8).uint64(message.sequence)
    }
    return writer
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgSendTxResponse {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMsgSendTxResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.sequence = reader.uint64()
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },
  fromPartial(object: Partial<MsgSendTxResponse>): MsgSendTxResponse {
    const message = createBaseMsgSendTxResponse()
    message.sequence =
      object.sequence !== undefined && object.sequence !== null
        ? BigInt(object.sequence.toString())
        : BigInt(0)
    return message
  },
  fromAmino(object: MsgSendTxResponseAmino): MsgSendTxResponse {
    const message = createBaseMsgSendTxResponse()
    if (object.sequence !== undefined && object.sequence !== null) {
      message.sequence = BigInt(object.sequence)
    }
    return message
  },
  toAmino(message: MsgSendTxResponse): MsgSendTxResponseAmino {
    const obj: any = {}
    obj.sequence =
      message.sequence !== BigInt(0) ? message.sequence.toString() : undefined
    return obj
  },
  fromAminoMsg(object: MsgSendTxResponseAminoMsg): MsgSendTxResponse {
    return MsgSendTxResponse.fromAmino(object.value)
  },
  toAminoMsg(message: MsgSendTxResponse): MsgSendTxResponseAminoMsg {
    return {
      type: 'cosmos-sdk/MsgSendTxResponse',
      value: MsgSendTxResponse.toAmino(message)
    }
  },
  fromProtoMsg(message: MsgSendTxResponseProtoMsg): MsgSendTxResponse {
    return MsgSendTxResponse.decode(message.value)
  },
  toProto(message: MsgSendTxResponse): Uint8Array {
    return MsgSendTxResponse.encode(message).finish()
  },
  toProtoMsg(message: MsgSendTxResponse): MsgSendTxResponseProtoMsg {
    return {
      typeUrl:
        '/ibc.applications.interchain_accounts.controller.v1.MsgSendTxResponse',
      value: MsgSendTxResponse.encode(message).finish()
    }
  }
}
GlobalDecoderRegistry.register(MsgSendTxResponse.typeUrl, MsgSendTxResponse)
GlobalDecoderRegistry.registerAminoProtoMapping(
  MsgSendTxResponse.aminoType,
  MsgSendTxResponse.typeUrl
)
function createBaseMsgUpdateParams(): MsgUpdateParams {
  return {
    signer: '',
    params: Params.fromPartial({})
  }
}
export const MsgUpdateParams = {
  typeUrl:
    '/ibc.applications.interchain_accounts.controller.v1.MsgUpdateParams',
  aminoType: 'cosmos-sdk/MsgUpdateParams',
  is(o: any): o is MsgUpdateParams {
    return (
      o &&
      (o.$typeUrl === MsgUpdateParams.typeUrl ||
        (typeof o.signer === 'string' && Params.is(o.params)))
    )
  },
  isSDK(o: any): o is MsgUpdateParamsSDKType {
    return (
      o &&
      (o.$typeUrl === MsgUpdateParams.typeUrl ||
        (typeof o.signer === 'string' && Params.isSDK(o.params)))
    )
  },
  isAmino(o: any): o is MsgUpdateParamsAmino {
    return (
      o &&
      (o.$typeUrl === MsgUpdateParams.typeUrl ||
        (typeof o.signer === 'string' && Params.isAmino(o.params)))
    )
  },
  encode(
    message: MsgUpdateParams,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    if (message.signer !== '') {
      writer.uint32(10).string(message.signer)
    }
    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(18).fork()).ldelim()
    }
    return writer
  },
  decode(input: BinaryReader | Uint8Array, length?: number): MsgUpdateParams {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMsgUpdateParams()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          message.signer = reader.string()
          break
        case 2:
          message.params = Params.decode(reader, reader.uint32())
          break
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },
  fromPartial(object: Partial<MsgUpdateParams>): MsgUpdateParams {
    const message = createBaseMsgUpdateParams()
    message.signer = object.signer ?? ''
    message.params =
      object.params !== undefined && object.params !== null
        ? Params.fromPartial(object.params)
        : undefined
    return message
  },
  fromAmino(object: MsgUpdateParamsAmino): MsgUpdateParams {
    const message = createBaseMsgUpdateParams()
    if (object.signer !== undefined && object.signer !== null) {
      message.signer = object.signer
    }
    if (object.params !== undefined && object.params !== null) {
      message.params = Params.fromAmino(object.params)
    }
    return message
  },
  toAmino(message: MsgUpdateParams): MsgUpdateParamsAmino {
    const obj: any = {}
    obj.signer = message.signer === '' ? undefined : message.signer
    obj.params = message.params ? Params.toAmino(message.params) : undefined
    return obj
  },
  fromAminoMsg(object: MsgUpdateParamsAminoMsg): MsgUpdateParams {
    return MsgUpdateParams.fromAmino(object.value)
  },
  toAminoMsg(message: MsgUpdateParams): MsgUpdateParamsAminoMsg {
    return {
      type: 'cosmos-sdk/MsgUpdateParams',
      value: MsgUpdateParams.toAmino(message)
    }
  },
  fromProtoMsg(message: MsgUpdateParamsProtoMsg): MsgUpdateParams {
    return MsgUpdateParams.decode(message.value)
  },
  toProto(message: MsgUpdateParams): Uint8Array {
    return MsgUpdateParams.encode(message).finish()
  },
  toProtoMsg(message: MsgUpdateParams): MsgUpdateParamsProtoMsg {
    return {
      typeUrl:
        '/ibc.applications.interchain_accounts.controller.v1.MsgUpdateParams',
      value: MsgUpdateParams.encode(message).finish()
    }
  }
}
GlobalDecoderRegistry.register(MsgUpdateParams.typeUrl, MsgUpdateParams)
GlobalDecoderRegistry.registerAminoProtoMapping(
  MsgUpdateParams.aminoType,
  MsgUpdateParams.typeUrl
)
function createBaseMsgUpdateParamsResponse(): MsgUpdateParamsResponse {
  return {}
}
export const MsgUpdateParamsResponse = {
  typeUrl:
    '/ibc.applications.interchain_accounts.controller.v1.MsgUpdateParamsResponse',
  aminoType: 'cosmos-sdk/MsgUpdateParamsResponse',
  is(o: any): o is MsgUpdateParamsResponse {
    return o && o.$typeUrl === MsgUpdateParamsResponse.typeUrl
  },
  isSDK(o: any): o is MsgUpdateParamsResponseSDKType {
    return o && o.$typeUrl === MsgUpdateParamsResponse.typeUrl
  },
  isAmino(o: any): o is MsgUpdateParamsResponseAmino {
    return o && o.$typeUrl === MsgUpdateParamsResponse.typeUrl
  },
  encode(
    _: MsgUpdateParamsResponse,
    writer: BinaryWriter = BinaryWriter.create()
  ): BinaryWriter {
    return writer
  },
  decode(
    input: BinaryReader | Uint8Array,
    length?: number
  ): MsgUpdateParamsResponse {
    const reader =
      input instanceof BinaryReader ? input : new BinaryReader(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMsgUpdateParamsResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7)
          break
      }
    }
    return message
  },
  fromPartial(_: Partial<MsgUpdateParamsResponse>): MsgUpdateParamsResponse {
    const message = createBaseMsgUpdateParamsResponse()
    return message
  },
  fromAmino(_: MsgUpdateParamsResponseAmino): MsgUpdateParamsResponse {
    const message = createBaseMsgUpdateParamsResponse()
    return message
  },
  toAmino(_: MsgUpdateParamsResponse): MsgUpdateParamsResponseAmino {
    const obj: any = {}
    return obj
  },
  fromAminoMsg(
    object: MsgUpdateParamsResponseAminoMsg
  ): MsgUpdateParamsResponse {
    return MsgUpdateParamsResponse.fromAmino(object.value)
  },
  toAminoMsg(
    message: MsgUpdateParamsResponse
  ): MsgUpdateParamsResponseAminoMsg {
    return {
      type: 'cosmos-sdk/MsgUpdateParamsResponse',
      value: MsgUpdateParamsResponse.toAmino(message)
    }
  },
  fromProtoMsg(
    message: MsgUpdateParamsResponseProtoMsg
  ): MsgUpdateParamsResponse {
    return MsgUpdateParamsResponse.decode(message.value)
  },
  toProto(message: MsgUpdateParamsResponse): Uint8Array {
    return MsgUpdateParamsResponse.encode(message).finish()
  },
  toProtoMsg(
    message: MsgUpdateParamsResponse
  ): MsgUpdateParamsResponseProtoMsg {
    return {
      typeUrl:
        '/ibc.applications.interchain_accounts.controller.v1.MsgUpdateParamsResponse',
      value: MsgUpdateParamsResponse.encode(message).finish()
    }
  }
}
GlobalDecoderRegistry.register(
  MsgUpdateParamsResponse.typeUrl,
  MsgUpdateParamsResponse
)
GlobalDecoderRegistry.registerAminoProtoMapping(
  MsgUpdateParamsResponse.aminoType,
  MsgUpdateParamsResponse.typeUrl
)
